module.exports = __webpack_public_path__ + "assets/group.ccf7fa17d137c60e87e60c7777fc048d.png";